import { create, v, w } from '@dojo/framework/core/vdom';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import css from '../css/topicgroup.m.css';
import { publish } from '@holmescorp/pub-sub';
import { Icon } from '@holmescorp/base-widgets';
const factory = create({ theme, nls: createNlsMiddleware('quiz') });
export const StudyplanButton = factory(({ middleware: { theme, nls } }) => {
    const themeCss = theme.classes(css);
    const { messages: { studyplan_button_title = '[quiz] studyplan_button_title' } } = nls();
    return v('div', {
        classes: [themeCss.action],
        role: 'button',
        xqa: 'studyplan-button',
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            publish('mystudyplan/view');
        },
        onkeydown: (event) => {
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    publish('mystudyplan/view');
            }
        }
    }, [
        v('span', { classes: [themeCss.actionText] }, [studyplan_button_title]),
        v('div', { classes: [themeCss.actionIcon] }, [w(Icon, { faname: 'angles-left', size: '2x' })])
    ]);
});
export default StudyplanButton;
